interface IQueryParam {
    key: string
    value: string
}

interface IParseAccountsQueryParamsProps{
    pathname: string
    queryParams: IQueryParam[]
    subdomain?: string
}

export function parseAccountsQueryParams({
    pathname,
    queryParams,
    subdomain
}: IParseAccountsQueryParamsProps){
    if ( pathname[ 0 ] === '/' ) pathname = pathname.slice(1)
    if ( !pathname && (!queryParams || queryParams.length === 0) ) return ''
    const params = []
    if ( subdomain ){
        params.push( `s=${ subdomain }` )
    }
    if ( 
        pathname &&
        (
            typeof BASENAME === 'undefined' ||
            BASENAME === '' ||
            (typeof BASENAME === 'string' && pathname.includes( BASENAME ))
        )
    ){
        params.push(`dl=aura-feature_${ pathname ?? '' }_`)
    }
    if ( queryParams && Array.isArray(queryParams) && queryParams.length > 0 ){
        params.push(`aura-params_${ queryParams.map( param => `aura-key=${ param.key }aura-value=${ param.value }` ) }`) // &${ getRouteParams().map( param => `${ param.key }=${ param.value }` ).join( '&' ) } creo que esto es para parametros GTM
    }
    return '?' + params.join('&')
}